import React, { PropTypes } from 'react';
import ObjectRelPersonsPerson from '../Person';
import RelSectionTemplate from '../../../shared/RelSectionTemplate';

const PersonList = ({ persons, title }) => {
    const entries = persons.map(edge => (
        <ObjectRelPersonsPerson key={ edge.node.PerId } person={ edge.node } />
    ));

    return (
        <RelSectionTemplate title={title}>
            <ul className="person-list object-list">
                { entries }
            </ul>
        </RelSectionTemplate>
    );
};

PersonList.propTypes = {
    persons: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};

PersonList.defaultTypes = {
    persons: [],
};

export default PersonList;


// WEBPACK FOOTER //
// ./app/components/Object/RelPersons/PersonList/index.jsx